export const getDefaultInvoicePartyObj = () => ({
  companyName: "",
  percentage: 0,
  attentionTo: "",
  percentageShare: "LPI",
  address1: "",
  address2: "",
});
